<modal-panel id="fms-vcc-filter-modal-panel" class="filter-panel" [title]="'Filter'" (close)="handleFmsVccFiltersFormCloseEvent()">
  <div id="fms-vcc-filter-modal-div-1" class="filter" [formGroup]="form">
    <div id="fms-vcc-filter-modal-div-2" class="filter__fields">
      <mat-grid-list cols="1" gutterSize="10px" rowHeight="85" id="fms-vcc-list-grid-list">
        <!-- Trip Reference -->
        <mat-grid-tile id="fms-vcc-filter-adx-reference-grid-tile">
          <dynamic-autocomplete
            formControlName="tripReference"
            formLabel="Trip Record Locator"
            tableName="Trip"
            columnName="ExternalReference"
            [emitString]="true"
            dataTestId="fms-vcc-filter-adx-reference" />
        </mat-grid-tile>        
        <!-- Card Number -->
        <mat-grid-tile id="fms-vcc-filter-card-number-grid-tile">
          <mat-form-field id="fms-vcc-filter-card-number-form-field" appearance="fill">
            <mat-label id="fms-vcc-filter-card-number-label">Card Last Four</mat-label>
            <input
              matInput
              [(ngModel)]="config.vccNumber"
              formControlName="vccNumber"
              id="fms-vcc-filter-card-number-input"
              maxlength="4"
              placeholder="Please Enter Last 4 Digits">
            @if(form.controls['vccNumber'].value){
              <button 
                id="fms-vcc-filter-card-number-button"
                matSuffix mat-icon-button
                type="button"
                (click)="clearFmsVccFilters('vccNumber')">
                  <mat-icon>close</mat-icon>
              </button>
            }
            <mat-error *ngIf="form.get('vccNumber')?.hasError('pattern')">
              Please enter exactly 4 digits.
            </mat-error>
          </mat-form-field>
        </mat-grid-tile>        
        <!-- Payment Provider -->
        <mat-grid-tile id="fms-vcc-filter-provider-id-grid-tile">
          <mat-form-field id="fms-vcc-filter-provider-id-form-field" appearance="fill">
            <mat-label id="fms-vcc-filter-provider-id-label">Payment Provider</mat-label>
            <mat-select
              [(ngModel)]="config.providerId"
              formControlName="providerId"
              id="fms-vcc-filter-provider-id-select">
              <mat-option>None</mat-option>
              @for (provider of providers; track provider.id) {
                <mat-option [value]="provider.id">{{provider.paymentProviderName}}</mat-option>
              }
            </mat-select>
            @if(form.controls['providerId'].value){
              <button 
                id="fms-vcc-filter-provider-id-button"
                matSuffix mat-icon-button
                type="button"
                (click)="clearFmsVccFilters('providerId')">
                  <mat-icon>close</mat-icon>
              </button>
            }
            @if(isLoading){
              <mat-progress-spinner matSuffix diameter="20" mode="indeterminate"></mat-progress-spinner>
            }
          </mat-form-field>
        </mat-grid-tile>
      </mat-grid-list>
      <mat-grid-list class="modal-filter-col-flex" [cols]="isSmall ? 1 : 2" gutterSize="10px" rowHeight="85">
        <!-- Issue Date From -->
        <mat-grid-tile id="fms-vcc-filter-issue-date-from-grid-tile">
          <mat-form-field id="fms-vcc-filter-issue-date-from-form-field" appearance="fill">
            <mat-label id="fms-vcc-filter-issue-date-from-label">Issue Date From</mat-label>
            <input
              id="fms-vcc-filter-issue-date-from-input"
              matInput
              [matDatepicker]="issueDateFrom" readonly
              [(ngModel)]="config.issueDateFrom"
              formControlName="issueDateFrom">
            <mat-hint>MM/DD/YYYY</mat-hint>
            <mat-datepicker #issueDateFrom id="fms-vcc-filter-issue-date-from-datepicker"></mat-datepicker>
            @if(form.controls['issueDateFrom'].value){
              <button 
                id="fms-vcc-filter-issue-date-from-button"
                matSuffix mat-icon-button
                type="button"
                (click)="clearFmsVccFilters('issueDateFrom')">
                  <mat-icon>close</mat-icon>
              </button>
            } @else {
              <mat-datepicker-toggle matIconSuffix [for]="issueDateFrom"></mat-datepicker-toggle>
            }
          </mat-form-field>
        </mat-grid-tile>
        
        <!-- Issue Date To -->
        <mat-grid-tile id="fms-vcc-filter-issue-date-to-grid-tile">
          <mat-form-field id="fms-vcc-filter-issue-date-to-form-field" appearance="fill">
            <mat-label id="fms-vcc-filter-issue-date-to-label">Issue Date To</mat-label>
            <input
              id="fms-vcc-filter-issue-date-to-input"
              matInput
              [matDatepicker]="issueDateTo" readonly
              [(ngModel)]="config.issueDateTo"
              formControlName="issueDateTo">
            <mat-hint>MM/DD/YYYY</mat-hint>
            <mat-datepicker #issueDateTo id="fms-vcc-filter-issue-date-to-datepicker"></mat-datepicker>
            @if(form.controls['issueDateTo'].value){
              <button 
                id="fms-vcc-filter-issue-date-to-button"
                matSuffix mat-icon-button
                type="button"
                (click)="clearFmsVccFilters('issueDateTo')">
                  <mat-icon>close</mat-icon>
              </button>
            } @else {
              <mat-datepicker-toggle matIconSuffix [for]="issueDateTo"></mat-datepicker-toggle>
            }
          </mat-form-field>
        </mat-grid-tile>
      </mat-grid-list>
    </div>
  </div>
  
  <ng-container id="fms-vcc-filter-modal-footer-container" modalPanelFooter>
    <div class="modal-footer">
      <button id="fms-vcc-filter-modal-button-clear-all" mat-stroked-button color="primary" type="button" (click)="clearFmsVccFilters('all')">
        <mat-icon id="fms-vcc-filter-clear-all-filter-button-icon">delete_outline</mat-icon>
        Clear All
      </button>
      <button id="fms-vcc-filter-modal-button-apply" mat-raised-button color="primary" type="button" (click)="applyFmsVccFilters()">Apply</button>
    </div>
  </ng-container>
</modal-panel>
